export default __webpack_public_path__ + "images/scheduledVideo.bae309391c8dfaa53b715572f63a4453.svg";